const OVERLAY_ID = 'sw-update-overlay';
const VISIBLE_CLASS = 'sw-update-overlay--visible';
const RELOAD_HANDLER_PROP = '__swReloadHandler';

function ensureBannerContainer() {
  const existing = document.getElementById(OVERLAY_ID);
  if (existing) {
    return {
      overlay: existing,
      card: existing.querySelector('.sw-update-overlay__card'),
      title: existing.querySelector('.sw-update-overlay__title'),
      reloadButton: existing.querySelector('[data-role="sw-update-reload"]'),
    };
  }

  const overlay = document.createElement('div');
  overlay.id = OVERLAY_ID;
  overlay.className = 'sw-update-overlay';
  overlay.hidden = true;
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');

  const content = document.createElement('div');
  content.className = 'sw-update-overlay__content';

  const card = document.createElement('div');
  card.className = 'sw-update-overlay__card';
  card.setAttribute('tabindex', '-1');

  const title = document.createElement('p');
  title.id = 'sw-update-overlay__title';
  title.className = 'sw-update-overlay__body sw-update-overlay__title';
  title.textContent = '新しいバージョンが利用可能です。';

  const actions = document.createElement('div');
  actions.className = 'sw-update-overlay__actions';

  const reloadButton = document.createElement('button');
  reloadButton.type = 'button';
  reloadButton.className = 'sw-update-overlay__button sw-update-overlay__button--primary';
  reloadButton.textContent = 'Reload';
  reloadButton.setAttribute('data-role', 'sw-update-reload');

  actions.appendChild(reloadButton);
  card.appendChild(title);
  card.appendChild(actions);
  content.appendChild(card);
  overlay.appendChild(content);

  overlay.setAttribute('aria-labelledby', title.id);

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) {
      event.stopPropagation();
      event.preventDefault();
    }
  });

  document.body.appendChild(overlay);

  return { overlay, card, title, reloadButton };
}

export function createServiceWorkerUpdateBanner({ onReload } = {}) {
  if (typeof document === 'undefined') {
    return {
      show: () => {},
      hide: () => {},
      destroy: () => {},
    };
  }

  const { overlay, card, reloadButton } = ensureBannerContainer();

  if (overlay[RELOAD_HANDLER_PROP]) {
    reloadButton.removeEventListener('click', overlay[RELOAD_HANDLER_PROP]);
  }

  const handleReload = async () => {
    if (typeof onReload === 'function') {
      try {
        await onReload();
      } catch (error) {
        // onReload で例外が発生しても握りつぶす
      }
    }
  };

  overlay[RELOAD_HANDLER_PROP] = handleReload;
  reloadButton.addEventListener('click', handleReload);

  const show = () => {
    if (overlay.hidden) {
      overlay.hidden = false;
    }
    overlay.classList.add(VISIBLE_CLASS);
    requestAnimationFrame(() => {
      card.focus();
    });
  };

  const hide = () => {
    overlay.classList.remove(VISIBLE_CLASS);
    overlay.hidden = true;
  };

  const destroy = () => {
    reloadButton.removeEventListener('click', handleReload);
    delete overlay[RELOAD_HANDLER_PROP];
    if (overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
  };

  return { show, hide, destroy };
}
